var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0934 13.2704C7.43066 13.2704 4.46289 10.2933 4.46289 6.63052C4.46289 2.96777 7.44005 0 11.0934 0C14.7468 0 17.7239 2.97716 17.7239 6.63052C17.7239 10.2839 14.7468 13.2704 11.0934 13.2704ZM11.0934 1.87833C8.47313 1.87833 6.34122 4.01024 6.34122 6.63052C6.34122 9.25079 8.47313 11.3921 11.0934 11.3921C13.7137 11.3921 15.8456 9.26019 15.8456 6.63052C15.8456 4.00085 13.7137 1.87833 11.0934 1.87833Z",
    fill: "#5F6267"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.0934 27.1606C6.91414 27.1606 2.95086 25.3292 0.227271 22.1361C-0.0263036 21.8449 -0.0732619 21.4223 0.114571 21.0842L1.04435 19.3749C2.51884 16.6607 5.34573 14.9796 8.4262 14.9796H13.7231C16.7284 14.9796 19.5178 16.6044 21.011 19.2059L22.0723 21.0654C22.2695 21.4129 22.232 21.8355 21.969 22.1455C19.2454 25.3386 15.2821 27.17 11.1028 27.17L11.0934 27.1606ZM2.07743 21.3847C4.42535 23.8641 7.67487 25.2823 11.0934 25.2823C14.512 25.2823 17.7521 23.8735 20.0907 21.4035L19.3675 20.1356C18.2123 18.107 16.0428 16.8486 13.7137 16.8486H8.41681C6.02193 16.8486 3.83367 18.154 2.68789 20.2577L2.07743 21.3847Z",
    fill: "#5F6267"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthUser);
export default __webpack_public_path__ + "static/media/AuthUser.2352d9265928afd230bd07b6595c04e7.svg";
export { ForwardRef as ReactComponent };